import { tileWidth, tileHeight } from './tileset.config';
import {
  IVfxPreset,
  IVfxComposition,
  IVfxEntry,
} from '../types/animation.types';

export type { IVfxPreset, IVfxComposition, IVfxEntry };

export const isVfxComposition = (e: IVfxEntry): e is IVfxComposition =>
  (e as IVfxComposition).type === 'composition';

/**
 * Preset registry keyed by spritesheet atlas name (for simple presets) or a
 * logical effect name (for compositions).
 * When createAnimation() is called with a name present here, these values are
 * used as defaults unless the caller explicitly overrides them.
 */
export const vfxConfig: Record<string, IVfxEntry> = {
  fire: {
    animationSpeed: 'auto',
    width: tileWidth,
    height: tileHeight,
  },
  'effects-omnislash': {
    width: tileWidth * 2,
    height: tileHeight * 2,
    animationSpeed: 'auto',
  },
  'effects-wide-axe': {
    width: tileWidth * 3,
    height: tileHeight * 3,
    animationSpeed: 'auto',
  },
  'effects-demon-slash': {
    width: tileWidth * 3,
    height: tileHeight * 3,
    animationSpeed: 'auto',
  },
  'effects-fireblast': {
    width: tileWidth * 2,
    height: tileHeight * 2,
  },
  'effects-starfall': {
    width: tileWidth * 2,
    height: tileHeight * 2,
    animationSpeed: 'auto',
  },
  'effects-aura': {
    width: tileWidth * 2,
    height: tileHeight * 2,
    animationSpeed: 'auto',
  },
  'effects-smoke': {
    width: tileWidth * 5,
    height: tileHeight * 5,
    anchor: [0.5, 0.8],
    animationSpeed: 'auto',
  },
  'effects-root': {
    width: tileWidth,
    height: tileHeight,
    animationSpeed: 'auto',
  },
  'effects-fireball': {
    width: tileWidth,
    height: tileHeight,
    animationSpeed: 'auto',
  },
  'effects-fireball-side': {
    width: tileWidth,
    height: tileHeight,
    animationSpeed: 'auto',
  },
  'effects-attraction': {
    width: tileWidth * 2,
    height: tileHeight * 2,
    animationSpeed: 'auto',
  },
  'effects-rock': {
    width: tileWidth * 2,
    height: tileHeight * 2,
    animationSpeed: 'auto',
  },
  'example-placeholder-composition': {
    type: 'composition',
    layers: [
      {
        spriteName: 'placeholders-run-bottom',
        zIndex: 0,
        animationSpeed: 'auto',
        loop: true,
        parallaxDepth: 1.1,
        maxParallaxOffset: 10,
      },
      {
        spriteName: 'placeholders-hurt-bottom',
        zIndex: 1,
        animationSpeed: 'auto',
        loop: true,
        parallaxDepth: 1,
      },
    ],
  },
};
